import moment from 'moment'

export default date => moment.utc().diff(date, 'seconds') >= 0
